import { StyleSheet, Platform } from 'react-native';
import { brand, neutrals, alert } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
  },
  badge: {
    borderRadius: 7,
    paddingHorizontal: 10,
    minHeight: 20,
    minWidth: 25,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
  },
  heartbeatBorder: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: alert.alertRed,
    borderRadius: 7,
    zIndex: 1,
  },
  digitsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    fontSize: 12,
    fontWeight: '700',
    lineHeight: 16,
    letterSpacing: 0,
  },
  warningTooltip: {
    position: 'absolute',
    bottom: 24,
    backgroundColor: neutrals.white,
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    zIndex: 100,
    alignItems: 'center',
  },
  warningTooltipText: {
    color: neutrals.black,
    fontSize: 12,
    lineHeight: 15.6,
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
});
